// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"43582c24","184":"e0f1c16b","392":"16cff521","426":"975840af"}[chunkId] + ".chunk.js";
};